import { Dialog, Button, Text } from '@/ui'

export const OnboardingModal = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean
  setShowModal: (value: boolean) => void
}) => {
  return (
    <Dialog
      open={showModal}
      onOpenChange={(val) => !val && setShowModal(false)}
    >
      <Dialog.Content className="max-w-sm">
        <Dialog.Title>Are you sure you want to skip?</Dialog.Title>

        <div className="flex gap-4 items-start">
          <img
            className="w-16 h-16 flex-shrink-0"
            src="https://heard-images.s3.amazonaws.com/assets/warning-logo.png"
            alt="Warning"
          />

          <div>
            <Text className="mb-1 font-bold">
              You need to connect a business checking account to use Heard.
            </Text>
            <Text className="mb-1">
              With a connected business bank account:
            </Text>
            <ul className="pl-5 list-disc text-sm">
              <li>Your bookkeeper can complete your catch-up bookkeeping</li>
              <li>
                You’ll receive a clear picture of your practice’s finances
              </li>
            </ul>
          </div>
        </div>

        <Dialog.Footer className="mt-6 flex justify-end gap-4">
          <Dialog.Close asChild>
            <Button variant="link" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
          </Dialog.Close>
          <Button variant="danger">Skip</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
